<script lang="ts" runes>
    import { Spinner } from "@/components";
    const {
        isOpen = false,
        title = null,
        message = "Are you sure?",
        labelOk = "OK",
        showCancelButton = true,
        labelCancel = "Cancel",
        labelThirdButton = "",
        onOk = () => {},
        onCancel = () => {},
        onThirdButton = () => {},
        btnType = "--primary",
        loading = false,
    } = $props();
</script>

{#if isOpen}
    <div class="dialog__overlay">
        <div class="dialog__modal">
            {#if loading}
                <div class="dialog__spinner">
                    <Spinner tiny={true} text="Redirigiendo a Stripe..." />
                </div>
            {/if}
            {#if title}
                <h2 class="dialog__title">{title}</h2>
            {/if}
            <p class="dialog__message">{message}</p>
            <div class="dialog__actions">
                {#if showCancelButton}
                    <button
                        class="dialog__btn --cancel"
                        on:click={() => onCancel()}
                    >
                        {labelCancel}
                    </button>
                {/if}
                <button class="dialog__btn {btnType}" on:click={() => onOk()}>
                    {labelOk}
                </button>
            </div>
            {#if labelThirdButton}
                <button
                    class="dialog__btn --third"
                    on:click={() => onThirdButton()}
                >
                    {labelThirdButton}
                </button>
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    @use "./styles/index.scss";
</style>
